// extracted by mini-css-extract-plugin
export default {"modalContainer":"Modal_modalContainer__QjqZb","off":"Modal_off__4HUy5","modal":"Modal_modal__DJDMv","closeButton":"Modal_closeButton__Ya+Ev"};